import React, { useMemo } from "react";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import { useTheme } from "@mui/material";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { OrgUsersLicenseActionCell } from "./OrgUsersLicense.action.cell";

export type TOrgUser = {
  product?: string;
  type?: string;
  productID?: string;
  invoice?: string;
  startDate?: string;
  orgID?: string;
  userID?: string;
};

const orgUsersLicenseCol: MRT_ColumnDef<TOrgUser>[] = [
  { header: "Product", accessorKey: "productName",  },
  { header: "Valid", 
    accessorKey: "valid",
    Cell: ({ cell }) => {
      const isValid = cell.getValue<boolean>();
      return (
        <span
          style={{
            backgroundColor: isValid ? "#BFE3C0" : "#F1ADAC",
            color: "#ffffff", 
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 500,
          }}
        >
          {isValid ? "Yes" : "No"}
        </span>
      );
    }
  },
  { header: "Invoice", accessorKey: "invoiceID",},
  { header: "Day left", accessorKey: "daysLeft"},
  { header: "Start Date", accessorKey: "startDate",},
  { header: "Expires in", accessorKey: "expirationDate",}
];

const OrgUsersLicenseTable = ({ row, source = "others" }) => {

  const theme = useTheme();
  const columns = useMemo<MRT_ColumnDef<TOrgUser>[]>(() => {
    const cols = [...orgUsersLicenseCol];

    if (source === "organization") {
      cols.push({
        header: "Action",
        Cell: OrgUsersLicenseActionCell,
      });
    }

    return cols;
  }, [source]);
  
  const getSubRows = (item) => {
    if (!row?.original?.license) return [];

    const commonData = {
      valid: item?.valid,
      userID: item?.userID,
      daysLeft: item?.daysLeft,
      type: item?.type,
      licenseKey: item?.licenseKey,
      expirationDate: item?.expirationDate,
    };  

    if(item?.seats?.length){
      return item.seats.map((seat) => ({
        ...commonData,
        invoiceID: seat?.invoiceID,
        seatID: seat?.seatID,
        productID: seat?.productID,
        startDate: seat?.startDate,
        productName: seat?.productName,
      }));
    }

    return [{
      ...commonData,
      invoiceID: null,
      seatID: null,
      productID: null,
      startDate: null,
      productName: null,
    }];
  }

  return (
    <>
      <AdminGlobalTable
        columns={columns}
        data={getSubRows(row?.original?.license)}
        config={{
          enableGlobalFilter: false,
          enableDensityToggle: false,
          enablePagination: false,
          enableEditing: false,

          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme?.custom?.hoverOptionColor },
            },
          }),
          renderTopToolbar: () => <></>,
        }}
      />
    </>
  );
};

export default OrgUsersLicenseTable;
